import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import TabItem from './Tab';
import Styles from './Tabs.module.scss';

export class Tabs extends React.PureComponent {
  state = {
    activeTab: this.props.activeTab ? this.props.activeTab : 0,
    pendingTabChange: null
  };

  static Tab = args => {
    const { children, ...props } = args;
    return <TabItem {...props}>{children}</TabItem>;
  };

  completePendingTabChange = (proceed = true) => {
    if (this.state.pendingTabChange !== null && proceed) {
      this.setState({
        activeTab: this.state.pendingTabChange,
        pendingTabChange: null
      });
    } else {
      this.setState({
        pendingTabChange: null
      });
    }
  };

  changeActiveTab = activeTabIndex => {
    const currentTab = React.Children.toArray(this.props.children)[
      this.state.activeTab
    ];

    // If we're already on this tab, do nothing
    if (this.state.activeTab === activeTabIndex) {
      return;
    }

    // Check if current tab has a validateTabChange function
    if (currentTab.props.validateTabChange) {
      // Set pending tab change
      this.setState({ pendingTabChange: activeTabIndex });

      // Call validateTabChange and pass our completion callback
      setTimeout(() => {
        currentTab.props.validateTabChange(this.completePendingTabChange);
      }, 0);
    } else {
      // No validation needed, change tab immediately
      this.setState(
        {
          activeTab: activeTabIndex
        },
        () => {
          if (this.props.onTabClick) {
            this.props.onTabClick(activeTabIndex);
          }
        }
      );
    }
  };

  render() {
    const tabItems = React.Children.toArray(this.props.children);
    const activeTab = tabItems[this.state.activeTab];
    return (
      <div className={cx(Styles.tabs, this.props.className)}>
        <div className={Styles.tabsList}>
          {React.Children.map(tabItems, (child, index) => {
            return React.cloneElement(child, {
              isActive: index === this.state.activeTab,
              onClick: this.changeActiveTab.bind(this, index)
            });
          })}
        </div>
        <div
          className={cx(
            activeTab.props.noBackground
              ? Styles.noBackgroundWrapper
              : Styles.activeTabWrapper
          )}
        >
          {activeTab &&
            React.isValidElement(activeTab.props.component) &&
            activeTab.props.component}
        </div>
      </div>
    );
  }
}

Tabs.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  className: PropTypes.string,
  activeTab: PropTypes.number,
  onTabClick: PropTypes.func
};
